/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceName } from './ServiceName';
import {
    ServiceNameFromJSON,
    ServiceNameFromJSONTyped,
    ServiceNameToJSON,
} from './ServiceName';

/**
 * 
 * @export
 * @interface BackOfficeApiKeyUpdateRequest
 */
export interface BackOfficeApiKeyUpdateRequest {
    /**
     * 
     * @type {ServiceName}
     * @memberof BackOfficeApiKeyUpdateRequest
     */
    service: ServiceName;
    /**
     * 
     * @type {boolean}
     * @memberof BackOfficeApiKeyUpdateRequest
     */
    isActive?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BackOfficeApiKeyUpdateRequest
     */
    scopes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyUpdateRequest
     */
    description?: string;
}



/**
 * Check if a given object implements the BackOfficeApiKeyUpdateRequest interface.
 */
export function instanceOfBackOfficeApiKeyUpdateRequest(value: object): value is BackOfficeApiKeyUpdateRequest {
    if (!('service' in value) || value['service'] === undefined) return false;
    return true;
}

export function BackOfficeApiKeyUpdateRequestFromJSON(json: any): BackOfficeApiKeyUpdateRequest {
    return BackOfficeApiKeyUpdateRequestFromJSONTyped(json, false);
}

export function BackOfficeApiKeyUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficeApiKeyUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'service': ServiceNameFromJSON(json['service']),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'scopes': json['scopes'] == null ? undefined : json['scopes'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function BackOfficeApiKeyUpdateRequestToJSON(value?: BackOfficeApiKeyUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'service': ServiceNameToJSON(value['service']),
        'isActive': value['isActive'],
        'scopes': value['scopes'],
        'description': value['description'],
    };
}

